// Display the view Not Found when the route doesn't match any route of react-router
import { ErrorPage } from '../../../../components/common';
import error from '../../../../assets/404-error.svg';

const NotFound = () => (
  <ErrorPage
    image={error}
    title={
      <>
        OOPS ! <br />
        Vous devez passer par votre application NEO pour accéder aux formulaires
      </>
    }
  />
);
export default NotFound;
